import { getStudentMaskedName, setStudentMaskedName } from "./studentIdentityStore";

export function copyStudentMaskAfterIdentifierChange(change) {
  if (Array.isArray(change)) {
    // Snapshot first so a newly copied mask cannot become another student's source.
    try {
      const copies = change.map((item) => ({
        ...item,
        mask: getStudentMaskedName(item.schoolId, item.previousIdentifier),
        targetMask: getStudentMaskedName(item.schoolId, item.identifier),
      }));
      for (const item of copies) {
        if (item.mask && !item.targetMask) setStudentMaskedName(item.schoolId, item.identifier, item.mask);
      }
    } catch (error) {
      console.warn("Nie udało się skopiować lokalnych masek na nowe identyfikatory.", error);
    }
    return;
  }
  if (!change || !change.previousIdentifier || !change.identifier || change.previousIdentifier === change.identifier) return;
  // The server has already committed; local storage must never turn success into an error.
  try {
    const mask = getStudentMaskedName(change.schoolId, change.previousIdentifier);
    if (mask && !getStudentMaskedName(change.schoolId, change.identifier)) {
      setStudentMaskedName(change.schoolId, change.identifier, mask);
    }
  } catch (error) {
    console.warn("Nie udało się skopiować lokalnej maski na nowy identyfikator.", error);
  }
}
